export default {
  data: () => ({
    books: [
      {
        title: "Carregades de raons",
        author: "Dolors Bassa i Montserrat Bassa",
        isbn: "978-8416915804",
        description:
          "«El vidre continua sent un autèntic mur emocional. Res de tocar, res d'abraçar ... cap relació epidèrmica.»<br />Dolors Bassa<br /><br /> «Tornaríem a fer petons a un vidre brut, però a la Dolors li arribaven al cor, i aquest gest, juntament amb el de les nostres mans a banda i banda d'aquell vidre, li donava forces.»",
        image: "LesVoltesOct2020Imgs/CarregadesDeRaons.png"
      },
      {
        title: "34 Dies De Tardor I 1 De Primavera. Diari De Presó",
        author: "Meritxell Borràs",
        isbn: "978-8415315568",
        description:
          "34 dies de tardor i 1 de primavera és el relat, ple de coratge i sensibilitat, del temps que Meritxell Borràs estigué a la presó d'Alcalà-Meco la tardor de 2017. Una crònica personal i directa d'uns dies en què, com diu Antoni Bassas, la set de revenja de l'Estat porta el Govern de Catalunya a la presó i a l'exili.",
        image: "LesVoltesOct2020Imgs/34DiesDeTardor.png"
      },
      {
        title: "Tres dies a la presó: Un diàleg sense murs",
        author: "Jordi Cuixart i Gemma Nierga",
        isbn: "978-8417627720",
        description:
          "Un diàleg intens de Jordi Cuixart i Gemma Nierga que permet comprendre una figura clau del present polític. «El procés afecta emocionalment tots els catalans, tant si pengem banderes del balcó com si ens prenen per equidistants, i els periodistes hem d'intentar prendre distància i explicar què està passant ara i aquí», afirma Gemma Nierga.",
        image: "LesVoltesOct2020Imgs/TresDiesALaPreso.png"
      },
      {
        title: "Des de l'exili",
        author: "David Ferrer",
        isbn: "978-8498094473",
        description:
          "El llibre que dona veu als exiliats del procés, amb informacions inèdites des del punt de vista polític i humà. Amb pròleg de Gonzalo Boye i epíleg de Carles Puigdemont.",
        image: "LesVoltesOct2020Imgs/DesDeLExili.png"
      },
      {
        title: "Entre togues i reixes: Escrits de judici i presó",
        author: "Joaquim Forn",
        isbn: "978-8441232051",
        description:
          "Entre togues i reixes és un llibre personal i íntim. Joaquim Forn es fixa en les petites coses i en tot allò que mai no ha aparegut en les transmissions des del Suprem. Ens explica com s'enfronta a la vida en una nova presó, la tercera, com es prepara per comparèixer davant del jutge, com viu la seva declaració i com encaixa la sentència.",
        image: "LesVoltesOct2020Imgs/EntreToguesIReixes.png"
      },
      {
        title: "Escrits de presó",
        author: "Joaquim Forn",
        isbn: "978-8441232006",
        description:
          "Des de l'entrada a la presó, el vespre del 2 de novembre de 2017, Joaquim Forn escriu un dietari on recull les vivències i dificultats compartides a la presó d'Estremera amb companys del Govern: Oriol Junqueras, Raül Romeva, Carles Mundó, Josep Rull i Jordi Turull.",
        image: "LesVoltesOct2020Imgs/EscritsDePreso.png"
      },
      {
        title:
          "Abans ningú deia t'estimo: Testimoni de filles i fills de presos polítics",
        author:
          "Anna Forn, Beta Forn, Laura Turull, Marta Turull i Oriol Sánchez",
        isbn: "978-8416673711",
        description:
          "Abans ningú deia t'estimo recull l'experiència intensa, dura, desconcertant i emotiva de quatre noies i un noi que veuen com els pares són empresonats, arran dels fets polítics de setembre i octubre del 2017 a Catalunya.",
        image: "LesVoltesOct2020Imgs/AbansNinguDeiaTEstimo.png"
      },
      {
        title: "I parlarem de vida! Discursos i conferències",
        author: "Anna Gabriel",
        isbn: "978-8416855186",
        description:
          "Les paraules de l’Anna Gabriel sempre ens donen esperança i ens esperonen a lluitar. En aquest llibre hem volgut condensar elements importants del seu pensament revolucionari.",
        image: "LesVoltesOct2020Imgs/IParlaremDeVida.png"
      },
      {
        title: "Tornarem a vèncer: I com ho tornarem a fer",
        author: "Oriol Junqueras i Marta Rovira",
        isbn: "978-8417804572",
        description:
          "Els dos màxims dirigents d'ERC, Oriol Junqueras i Marta Rovira, l'un des de la presó de Lledoners i l'altra des de l'exili de Ginebra, concreten en aquest llibre escrit a quatre mans l'estratègia per aconseguir la independència.",
        image: "LesVoltesOct2020Imgs/TornaremAVencer.png"
      },
      {
        title: "Oriol Junqueras. Fins que siguem lliures",
        author: "Sergi Sol",
        isbn: "978-8416915729",
        description:
          "Oriol Junqueras i Carles Puigdemont van ser els principals artífexs institucionals de l'èpica col·lectiva que protagonitzàrem l'1 d'octubre. De vegades, amb una encomiable determinació; d'altres, a empentes i rodolons.",
        image: "LesVoltesOct2020Imgs/FinsQueSiguemLliures.png"
      },
      {
        title: "Parlant amb tu d'amor i llibertat",
        author: "Oriol Junqueras",
        isbn: "978-8417804312",
        description:
          "Oriol Junqueras ens regala històries i lectures que ens fan reflexionar i ens inspiren. Quan ets lluny, les paraules són les millors missatgeres: ens acosten a les persones que estimem, ressonen dins nostre de maneres imprevistes i ens permeten expressar el que sentim.",
        image: "LesVoltesOct2020Imgs/ParlantAmbTuDAmorILlibertat.png"
      },
      {
        title: "El referèndum inevitable: Del judici endavant",
        author: "Carles Mundó",
        isbn: "978-8498094565",
        description:
          "És imprescindible mantenir una moral de victòria; si en lloc de flagel·lar-nos per allò que encara no hem aconseguit som capaços de donar valor al camí que sí que hem recorregut, segur que sabrem trobar la manera de mantenir l'ànim i les forces per continuar treballant.",
        image: "LesVoltesOct2020Imgs/ElReferendumInevitable.png"
      },
      {
        title: "M'explico: De la investidura a l'exili",
        author: "Carles Puigdemont i Xevi Xirgo",
        isbn: "978-8416863914",
        description:
          "Amb la publicació d'aquest llibre, Carles Puigdemont trenca el seu silenci sobre què va passar durant la seva legislatura a la Generalitat i, especialment, durant el mes d'octubre de 2017, des del referèndum de l'1-O fins a la seva marxa a Bèlgica.",
        image: "LesVoltesOct2020Imgs/MExplico.png"
      },
      {
        title: "La lluita a l'exili",
        author: "Carles Puigdemont i Xevi Xirgo",
        isbn: "978-8416863952",
        description:
          "«Sento que he de protegir urgentment el que hem fet. En defensa pròpia i de tots els que creiem en el procés. Em sembla que el relat està ple de clarobscurs. No és un tractat de política, ni d'història, ni un monument a segons quines creences. És un llibre vital, com ho ha estat aquest període per a moltes persones.»",
        image: "LesVoltesOct2020Imgs/LaLluitaALExili.png"
      },
      {
        title: "La crisi catalana: Una oportunitat per a Europa",
        author: "Carles Puigdemont i Olivier Mouton",
        isbn: "978-8416863464",
        description:
          "«La crisi catalana és una crisi europea, i no només espanyola. Posa la Unió Europea a prova i l'obliga a demostrar si està disposada a situar els interessos dels ciutadans per damunt dels d'alguns estats membres.»<br />Carles Puigdemont",
        image: "LesVoltesOct2020Imgs/LaCrisiCatalana.png"
      },
      {
        title: "Esperança i llibertat",
        author: "Raül Romeva",
        isbn: "978-8416915859",
        description:
          "«Escric sobre esperança i llibertat, sense pocions màgiques ni mapes del tresor, però amb el cap alt, la mirada llarga, el verb serè i la mà estesa, amb pas decidit cap a la República.»",
        image: "LesVoltesOct2020Imgs/EsperancaILlibertat.png"
      },
      {
        title: "Des del banc dels acusats",
        author: "Raül Romeva",
        isbn: "978-8417804237",
        description:
          "Després de passar pels centres penitenciaris d’Estremera, Lledoners i Soto del Real, Raül Romeva ha fet dels seus dibuixos una manera d’expressar-se, de comunicar les seves conviccions, de recollir les impressions quan es viu privat de llibertat.",
        image: "LesVoltesOct2020Imgs/DesDelBancDelsAcusats.png"
      },
      {
        title: "Ubuntu: La república del bé comú",
        author: "Raül Romeva",
        isbn: "978-8418197208",
        description:
          "Això és ubuntu. Em reconec en la mesura que et reconec a tu. La teva felicitat és la nostra. No té a veure amb tu o amb mi, té a veure amb nosaltres. Només si ens veiem com a part integrant d'un ecosistema més ampli i complex podrem existir, ser.",
        image: "LesVoltesOct2020Imgs/Ubuntu.png"
      }
    ]
  })
};
